module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0033.jpg?v=dd46b62c";